<template>
    <el-dialog title="车辆信息" :visible.sync="dialogVisible" width="400px">
        <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-position="left">
            <el-form-item label="车辆照片" prop="vehiclePhoto">
                <up-img :file.sync="form.vehiclePhoto" width="200" height="135"></up-img>
            </el-form-item>
            <el-form-item label="车辆号牌" prop="licenseNoText">
                <el-input v-model="form.licenseNoText" placeholder="请输入车辆号牌码" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="车辆型号" prop="vehicleModel">
                <choose-model :modelValue.sync="form.vehicleModel"></choose-model>
            </el-form-item>
            <el-form-item label="车身颜色" prop="vehicleColor">
                <el-select v-model="form.vehicleColor">
                    <el-option v-for="item in $const.VEHICLECOLOR" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="车辆编号" prop="vehicleNo">
                <el-input v-model="form.vehicleNo" placeholder="请输入车辆编号"></el-input>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
            <el-button size="medium" type="primary" @click="submitForm" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import chooseModel from '../create/chooseModel.vue'
export default {
    components: {
        chooseModel
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        vehicleInfo: {
            type: Object,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                vehiclePhoto: '',
                licenseNoText: '',
                vehicleModel: '',
                vehicleColor: '',
                vehicleNo: ''
            },
            rules: {
                vehiclePhoto: [
                    { required: true, message: '请上传车辆照片', trigger: 'change' }
                ],
                licenseNoText: [
                    { required: false, message: '请输入车辆号牌码', trigger: 'blur' }
                ],
                vehicleModel: [
                    { required: true, message: '请选择车辆型号', trigger: 'change' }
                ],
                vehicleColor: [
                    { required: true, message: '请选择车身颜色', trigger: 'change' }
                ],
                vehicleNo: [
                    { required: false, message: '请输入车辆编号', trigger: 'blur' }
                ]
            }
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            if (val) {
                this.initForm();
            }
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        initForm() {
            this.form = {
                vehiclePhoto: this.vehicleInfo.vehiclePhoto || '',
                licenseNoText: this.vehicleInfo.licenseNo + '（如需修改请更新行驶证）',
                licenseNo: this.vehicleInfo.licenseNo,
                vehicleModel: this.vehicleInfo.vehicleModel || '',
                vehicleColor: this.vehicleInfo.vehicleColor || '',
                vehicleNo: this.vehicleInfo.vehicleNo || ''
            };
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$emit('submit', {
                        vehiclePhoto: this.form.vehiclePhoto,
                        licenseNo: this.form.licenseNo,
                        vehicleModel: this.form.vehicleModel,
                        vehicleColor: this.form.vehicleColor,
                        vehicleNo: this.form.vehicleNo,
                    });
                }
            });
        }
    }
}
</script>